import styled from 'styled-components';

export const DeleteContainer = styled.div`
  display: flex;

  & > div:first-child {
    margin-right: 18px;
    margin-bottom: 16px;
  }

  & > div:last-child {
    align-self: flex-start;
    cursor: pointer;
    margin-top: 2px;
  }
`;

export const AddressWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: fit-content;

  & > div:last-child {
    align-self: flex-end;
    .ant-btn {
      padding: 0;
    }
  }
`;

export const MainContainer = styled.div`
  margin-top: 24px;
`;

export const HolidayWrapper = styled.div`
  margin-top: 24px;

  & > div:first-child {
    margin-bottom: 16px;
  }
`;
